import type { MenuSectionItemProps } from 'src/components/common/Menu/global-navigation'

export const Item = ({ item }: MenuSectionItemProps) => {
  return (
    <>
      <span
        className="block text-sm font-semibold tracking-[-0.42px]"
        style={{ color: item?.titleColor ?? '' }}
      >
        {item?.title}
      </span>
      {item?.subtitle && (
        <span
          style={{
            color: item?.subtitleColor ? item?.subtitleColor : '#2C2C35',
          }}
          className="block text-xs font-light tracking-[-0.6px] max-w-full text-ellipsis overflow-hidden whitespace-nowrap"
        >
          {item.subtitle}
        </span>
      )}
    </>
  )
}
